// extracted by mini-css-extract-plugin
export var columns = "cq_jJ";